import React from "react";

const PHRASES = [
  "WAH GWAAN", "MI DEH YA", "NUH DUTY VIBE", "FULLY TURAH", "BLESS UP",
  "IRIE VIBES", "SMALL AXE", "OUT AH MANY ONE", "TURAHTID SOUND", "NO BAD VIBES",
];

export function PatoisMarquee() {
  const strip = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="patois-marquee"
      className="bg-jamaica-green/15 border-y border-jamaica-green/40 py-2.5 overflow-hidden"
    >
      <div className="marquee-track">
        {strip.map((p, i) => (
          <span key={i} className="font-mono text-[11px] tracking-[0.25em] uppercase text-jamaica-green mx-6">
            {p} <span className="text-jamaica-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
